<template>
    <div>
        <div class="row text-center mt-2">
            <div class="col-sm-6 text-left align-self-center">{{ ovpJobCondition.name }}</div>
            <div class="col-sm-2 text-center align-self-center">{{ ovpJobCondition.period }}</div>
            <div class="col-sm-2 align-self-center">
                <font-awesome-icon v-if="ovpJobCondition.isSpecial" icon="toggle-on" class="mr-1"/>
                <font-awesome-icon v-else icon="toggle-off" class="mr-1"/>
            </div>
            <div class="col-sm-2 d-flex justify-content-end align-self-center">
                <button class="ds-btn mr-1" @click="isModalVisible = true" v-b-tooltip.hover.viewport title="Apskatīt/Rediģēt">
                    <font-awesome-icon icon="eye"/>
                </button>
                <b-modal v-model="isModalVisible" no-close-on-backdrop hide-footer body-class="p-2"
                         header-class="bg-light align-items-center" size="lg">
                    <div slot="modal-title">
                        <h3 class="h4 text-dark font-weight-light m-0">{{ ovpJobCondition.name }}</h3>
                    </div>
                    <div slot="modal-header-close">
                    </div>
                    <OvpJobConditionBaseForm @finished="handleOvpJobConditionyUpdate" :current-ovp-job-condition="ovpJobCondition"/>
                </b-modal>
                <button v-if="!!currentCompany._id" class="ds-btn ds-btn--danger" @click="handleOvpJobConditionRemoval" v-b-tooltip.hover.viewport title="Dzēst">
                    <font-awesome-icon icon="trash"/>
                </button>
            </div>
        </div>
        <hr class="my-2"/>
    </div>
</template>
<script>
    import {mapActions, mapGetters, mapMutations} from 'vuex';

    import {OvpJobCondition} from '../../vuex/modules/ovp/models/ovp-job-condition.models';
    import OvpJobConditionBaseForm from './OvpJobConditionBaseForm';
    import * as ovpStoreTypes from '../../vuex/modules/ovp/ovp.store-types';
    import * as companyStoreTypes from '../../vuex/modules/company/company.store-types';
    import * as rootStoreTypes from '../../vuex/root.store-types'
    import * as authStoreTypes from "../../vuex/modules/auth/auth.store-types";

    export default {
        name: 'ovp-job-condition-list-item',
        components: {OvpJobConditionBaseForm},
        props: {
            ovpJobCondition: {
                type: OvpJobCondition,
                required: true,
            }
        },
        data: () => ({
            isModalVisible: false,
        }),
        computed: {
            ...mapGetters('ovp', {
                /** @type {function|*} */
                isActiveRequest: ovpStoreTypes.GET_IS_ACTIVE_REQUEST,
            }),
            ...mapGetters('company', {
                currentCompany: companyStoreTypes.GET_CURRENT_COMPANY,
            }),
            ...mapGetters('auth', {
                /** @type {CurrentUser|*} */
                currentUser: authStoreTypes.GET_CURRENT_USER,
            }),
        },
        methods: {
            ...mapMutations({
                /** @type {function|*} */
                setAlertData: rootStoreTypes.SET_ALERT_DATA,
            }),
            ...mapMutations('company', {
                /** @type {function|*} */
                setCurrentCompanyOvpJobConditions: companyStoreTypes.SET_CURRENT_COMPANY_OVP_JOB_CONDITIONS,
            }),
            ...mapActions('ovp', {
                /** @type {function|*} */
                removeOvpJobCondition: ovpStoreTypes.ACTION_REMOVE_OVP_JOB_CONDITION,
                /** @type {function|*} */
                getOvpJobConditions: ovpStoreTypes.ACTION_GET_OVP_JOB_CONDITIONS,
                /** @type {function|*} */
                updateOvpJobCondition: ovpStoreTypes.ACTION_UPDATE_OVP_JOB_CONDITION,
            }),
            async handleOvpJobConditionRemoval() {
                const hasConfirmed = await this.$bvModal.msgBoxConfirm('Esi pārliecināts, ka vēlies dzēst darba apstākli?', {
                    okTitle: 'Jā',
                    cancelTitle: 'Nē',
                });

                if (!hasConfirmed) {
                    return;
                }

                try {
                    await this.removeOvpJobCondition({ovpJobConditionId: this.ovpJobCondition._id, companyId: this.currentCompany._id});

                    this.setAlertData({type: 'primary', message: 'Darba apstāklis izdzēsts!'});
                    const ovpJobConditions = await this.getOvpJobConditions({companyId: this.currentCompany._id});

                    if (!this.currentCompany._id) {
                        return;
                    }
              
                    this.setCurrentCompanyOvpJobConditions(ovpJobConditions);
                } catch (err) {
                    //
                }
            },
            async handleOvpJobConditionyUpdate() {
                this.isModalVisible = false;
                this.getOvpJobConditions({companyId: this.currentCompany._id});
            },
        },
    }
</script>